module.exports = __webpack_public_path__ + "img/hhnm_gallery1.f625c088.jpg";